import { useState, useEffect } from 'react'
import { AiOutlineInfoCircle, AiOutlineCloseCircle, AiOutlineCheck, AiOutlineClose } from 'react-icons/ai'
import $ from 'jquery'
import parse from 'html-react-parser'

import { sendRequest } from '../Global/functions'
import { supportInfo } from '../Global/constants'

import FeedbackForm from '../FeedbackForm';
import LoginForm from './LoginForm';
import RegistrationForm from './RegistrationForm';
import WelcomeScreen from './WelcomeScreen';

import '../../css/login-handler.css'



export const LoginHandler = ({ answerKey, rawAnswers, togglePopup }) => {

    // -- loginclickcounter
    const [loginClicksCounter, setLoginClicksCounter] = useState(0);

    // -- error-message
    const [errorMessage, setErrorMessage] = useState("");

    // -- special error-message if sending-mail failed
    const [mailingSuccess, setMailSuccess] = useState();

    // -- active login/registration step
    const [activeStep, setActiveStep] = useState(0);

    // -- is teilnehmer a doctor (only for gcp-courses)
    const [isDoc, setisDoc] = useState(true);

    // -- user is new (only for wording-purposes)
    const [newUser, setNewUser] = useState();

    // -- this teilnehmer
    const [thisUser, setThisUser] = useState({});

    // -- agreement that user solved course on his/her own
    const [courseAgreement, setCourseAgreement] = useState(false);

    // -- name of identification-number
    const [nameOfArztID, setNameOfArztID] = useState("Fortbildungsnummer");
    const [nameOfArztIDPlaceholder, setNameOfArztIDPlaceholder] = useState("Ihre Fortbildungsnummer");

    // -- states for confirmation-form
    const [failedCourse, setFailedCourse] = useState(false);
    const [finalMessage, setFinalMessage] = useState("");


    // -- if these states change - clear error-message
    useEffect(() => { clearErrorMessage(); }, [thisUser, activeStep, courseAgreement, finalMessage, failedCourse]);
    const clearErrorMessage = () => {
        if (errorMessage) {
            // clear all wrong-input elements
            const wrongInputs = document.querySelectorAll('.wrong-input');
            for (let i = 0; i < wrongInputs.length; i++) {
                const thisInput = wrongInputs[i];
                thisInput.classList.remove('wrong-input');
            }
            // clear error message
            setErrorMessage("");
        }
    }


    // -- managion steps through login/registration
    /**
     *  Jump to specific STEP
     *  - Step 0: Welcome-Screen
     *  - Step 1: is-doctor form (only in gcp)
     *  - Step 2: no doctor is-new form (only in gcp)
     *  - Step 3: login form
     *  - Step 4: registration form
     *  - Step 5: confirmation form
     * 
     * @param {Integer} step - step-number
    */
    //#region 
    function jumpToStep(step) {
        // set active step
        setActiveStep(step);

        // scroll
        const loginContainer = document.querySelector('#loginHandler-container');
        loginContainer.scrollIntoView();

        if (step === 0) resetAll();
    }

    // ---- GCP-HANDLING ----
    // STEP 1: is a doctor?
    function handleIsDoc(isDocBool) {
        setisDoc(isDocBool);
        if (isDocBool) {
            // user is a doctor
            jumpToStep(3);
        }
        else {
            // user is no doctor
            jumpToStep(2);
        }
    }
    // STEP 2: is new?
    function handleIsNew(isNewBool) {
        setNewUser(isNewBool);
        jumpToStep(3);
        if (isNewBool) {
            // user is new
            getRandomEFN();
        }
    }
    //#endregion



    // -- input-change for all inputs
    //#region 

    // standard on-change function
    const onChange = (e, key) => {

        // input-field
        const input = e.currentTarget;
        // type of input field
        const type = input.getAttribute('type');

        // set new value depinding of text- or checkbox-input
        var newValue;
        if (type === "checkbox") newValue = input.checked ? 1 : 0;
        else newValue = input.value;

        setThisUser((prevState) => ({
            ...prevState,
            [key]: newValue
        }));
    }

    // efn changed
    const handleEfnChange = (event) => {
        var newEntryKey = event.nativeEvent.data;
        var newEfn = event.currentTarget.value;

        // only validate if isDoc = true
        if (isDoc) {
            // check if number is entered
            switch (thisUser.Land) {
                case "Deutschland":
                    if (/\d/.test(newEntryKey) || newEntryKey === null) {
                        // stop if efn-length > 15
                        if (newEfn.length > 15) {
                            return false;
                        }
                    }
                    else {
                        return false;
                    }
                    break;

                case "Österreich":
                    if (/\d/.test(newEntryKey) || newEntryKey === null) {

                        // stop if efn-length > 8
                        if (newEfn.length > 8) {
                            return false;
                        }
                        else {
                            // make sure format is xxxxx-xx
                            newEfn = newEfn.replace(/-/g, "");
                            if (newEfn.length !== 6 || newEntryKey === null) {
                                var newEfn = newEfn.substring(0, 5) + "-" + newEfn.substring(5, (newEfn.length));
                            }
                        }
                    }
                    else {
                        return false;
                    }
                    break;

                default:
                    // everything is allowed
                    break;
            }
        }
        else {
            // if gcp only check efn length
            if (newEfn.length > 15) return false;
        }

        // set efn of user
        setThisUser((prevState) => ({
            ...prevState,
            EFN: newEfn
        }));
    }

    // Land change
    function handleCountryChange(event) {

        const country = event.target.value;

        // country decides which wording to be used
        switch (country) {
            case "Deutschland":
                setNameOfArztID("EFN");
                setNameOfArztIDPlaceholder("Ihre 15-stellige EFN-Nummer");
                break;
            case "Österreich":
                setNameOfArztID("ÖÄK");
                setNameOfArztIDPlaceholder("Ihre 7-stellige ÖÄK-Nummer");
                break;

            default:
                setNameOfArztID("Arzt-ID");
                setNameOfArztIDPlaceholder("Ihre Arzt-ID");
                break;
        }
        if (!isDoc) {
            setNameOfArztID("Fortbildungsnummer");
            setNameOfArztIDPlaceholder("Ihre Fortbildungsnummer");
        }
        if (isDoc) {
            // reset efn only if doctor
            setThisUser((prevState) => ({
                ...prevState,
                EFN: ""
            }));
        }
        // set country
        setThisUser((prevState) => ({
            ...prevState,
            Land: country
        }));
    }
    //#endregion



    // -- go back to welcome screen
    function resetAll() {

        // uncheck all checkboxes
        $('input:checkbox').prop("checked", false);

        // clear error fields
        document.querySelectorAll('.error-message').forEach(elem => {
            elem.innerHTML = "";
        });

        // remove red-color in wrong input fields
        var inputErrors = document.querySelectorAll('.wrong-input');
        inputErrors.forEach((elem) => {
            elem.classList.remove('wrong-input');
        })

        // reset variables
        setisDoc(true);
        setNewUser();
    }


    // -- GET-Request to backend for random EFN (if no doctor)
    const getRandomEFN = async () => {

        // CREATE NEW RANDOM EFN FOR GCP-TEILNEHMER
        const response = await sendRequest('GET', '/kursteilnahme/getRandomEfn');

        if (response.success) {
            // set efn to user state
            setThisUser((prevState) => ({
                ...prevState,
                EFN: response.data.EFN
            }));
        }
        else {
            // failure
            setErrorMessage(
                `<div>
                    Fehler bei EFN-Generierung.
                    <br>
                    <span style='color: black'>
                        Bitte wenden Sie sich an unseren Support unter: 
                        ${supportInfo}
                    </span>
                </div>`
            );
        }
    }


    return (
        <div id="loginHandler-container">

            {activeStep === 0 ?

                // WELCOME-SCREEN -> step 0 - displayed before everything else
                <WelcomeScreen jumpToStep={jumpToStep} rawAnswers={rawAnswers} />

                :

                // FORM-CONTAINER -> step 1 - 5
                <div className="forms-container">


                    {/* header for registration and login */}
                    {(activeStep === 3 || activeStep === 4) ?
                        <h4>{(activeStep === 3) ? "Login" : <>{(!newUser) ? "Bitte überprüfen Sie Ihre Daten" : "Registrieren"}</>}</h4>
                        :
                        ""
                    }



                    {/* ISDOCTOR-FORM - only in GCP */}
                    {activeStep === 1 ?
                        <form id="isDoc-form" className="loginHandler-form">

                            <div className="form-input-container">
                                <div className="forCheckbox">
                                    <input id="isDoc-input" type="checkbox" onClick={() => handleIsDoc(true)} />
                                    <label htmlFor="isDoc-input">Ich bin Arzt (m/w/d)</label><br />
                                </div>

                                <div className="forCheckbox">
                                    <input id="isNoDoc-input" type="checkbox" onClick={() => handleIsDoc(false)} />
                                    <label htmlFor="isNoDoc-input">Ich bin <u>kein</u> Arzt (m/w/d)</label><br />
                                </div>

                            </div>

                        </form>
                        : <></>
                    }



                    {/* NewUser-FORM - only in GCP */}
                    {activeStep === 2 ?
                        <form id="isNew-form" className="loginHandler-form">

                            <div className="form-input-container">

                                <div className="forCheckbox">
                                    <input id="isNew-input" type="checkbox" onClick={() => handleIsNew(false)} />
                                    <label htmlFor="isNew-input">Ich habe bereits mindestens ein Modul des GCP-Kurses absolviert und habe bereits eine Teilnehmernummer erhalten.</label><br />
                                </div>

                                <div className="forCheckbox">
                                    <input id="isNotNew-input" type="checkbox" onClick={() => handleIsNew(true)} />
                                    <label htmlFor="isNotNew-input">Dies ist mein erstes Modul des GCP-Kurses. Ich habe noch keine Teilnehmernummer erhalten.</label><br />
                                </div>

                                <div className='show-on-hover' onClick={(e) => { e.currentTarget.querySelector('.popup').toggleAttribute('active') }}>
                                    <div><AiOutlineInfoCircle />Was ist eine Teilnehmernummer?</div>
                                    <div className='popup'>
                                        <span className='popup-exit'><AiOutlineCloseCircle /></span>
                                        <p>Wenn Sie bereits an mindestens einem Modul des GCP-Kurses teilgenommen haben, wurde Ihnen bei der erstmaligen Registrierung eine 15-stellige Teilnehmernummer zugewiesen. Die Teilnehmernummer findet sich auf Ihren Teilnahmebescheinigungen, die Sie per Email erhalten haben.</p>
                                    </div>
                                </div>

                            </div>

                        </form>
                        : <></>
                    }



                    {/* LOGIN-FORM */}
                    {activeStep === 3 ?
                        <>
                            <LoginForm
                                jumpToStep={jumpToStep}
                                isDoc={isDoc}
                                newUser={newUser} setNewUser={setNewUser}
                                thisUser={thisUser} setThisUser={setThisUser}

                                errorMessage={errorMessage} setErrorMessage={setErrorMessage}
                                clearErrorMessage={clearErrorMessage}

                                nameOfArztID={nameOfArztID} nameOfArztIDPlaceholder={nameOfArztIDPlaceholder}

                                handleCountryChange={handleCountryChange}
                                handleEfnChange={handleEfnChange}
                                onChange={onChange}
                            />
                        </>
                        : <></>
                    }



                    {/* REGISTRATION-FORM */}
                    {activeStep === 4 ?
                        <RegistrationForm
                            jumpToStep={jumpToStep}
                            isDoc={isDoc}
                            newUser={newUser}
                            thisUser={thisUser} setThisUser={setThisUser}
                            answerKey={answerKey}

                            loginClicksCounter={loginClicksCounter} setLoginClicksCounter={setLoginClicksCounter}

                            courseAgreement={courseAgreement} setCourseAgreement={setCourseAgreement}

                            errorMessage={errorMessage} setErrorMessage={setErrorMessage}
                            setMailSuccess={setMailSuccess}

                            nameOfArztID={nameOfArztID} nameOfArztIDPlaceholder={nameOfArztIDPlaceholder}

                            handleEfnChange={handleEfnChange}
                            onChange={onChange}

                            setFailedCourse={setFailedCourse}
                            setFinalMessage={setFinalMessage}
                        />
                        : <></>
                    }




                    {/* FINISHED LOGIN */}
                    {activeStep === 5 ?
                        <>
                            {/* confirmation */}
                            <form id="confirmation-form" failed={failedCourse ? "true" : "false"} className="loginHandler-form" >
                                {failedCourse ?
                                    <AiOutlineClose />
                                    :
                                    <AiOutlineCheck />
                                }
                                <div className="success-message">{parse(finalMessage)}</div>
                            </form>

                            {/* display a warning if mail dispatch failed */}
                            {mailingSuccess === false && !failedCourse ?
                                <div className="error-message">
                                    {parse(`
                                        Leider konnte die E-Mail mit Ihrem Zertifikat nicht zugestellt werden, Ihre Teilnahme wurde dennoch registriert und wird automatisch Ihrem Punktekonto gutgeschrieben.
                                        <br>
                                        Falls Sie das Zertifikat zu diesem Kurs benötigen, wenden Sie sich bitte an unseren Support unter:
                                        ${supportInfo}
                                        `)
                                    }
                                </div> :
                                <></>
                            }

                            {/* FAILURE - button */}
                            {failedCourse ?
                                <button className="my-btn" onClick={() => { jumpToStep(0); togglePopup() }}>
                                    Zurück zu den Wissensfragen
                                </button>
                                : <></>
                            }

                            {/* feedback-form */}
                            <FeedbackForm userMail={thisUser.Mail} />


                            {/* SUCCESS - button */}
                            {!failedCourse ?
                                <>
                                    <div className='closePage-message'>
                                        Vielen Dank für Ihre Teilnahme. Sie können diese Seite nun schließen.
                                    </div>
                                    <button className="my-btn" onClick={() => { jumpToStep(0); togglePopup() }}>
                                        Schließen
                                    </button>
                                </>
                                : <></>
                            }
                        </>
                        :
                        // cancel button                         
                        <button className="my-btn" onClick={() => jumpToStep(0)}>
                            Abbrechen
                        </button>
                    }
                </div>
            }
        </div>
    )
}

export default LoginHandler